module.exports = __webpack_public_path__ + "img/key_b.d7b5a4f4.svg";